import React, { useState, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import { getUserById, getBookingsUserById } from "../Services/userService";
import { RoutesPaths } from "../Router/constant";
import Skeleton from '../Components/SkeletonLoader'

export default function Usermanagementdetail() {
  const { id } = useParams();
  const [singleUserData, setSingleUserData] = useState(null);
  const [bookingUserData, setBookingUserData] = useState(null);
  useEffect(() => {
    if (id) {
      fetchUserData();
      fetchBookingData();
    }
  }, [id]);
  const isUserLoading = singleUserData === null;

  const fetchUserData = async () => {
    try {
      const usersResp = await getUserById(id);
      const user = usersResp?.data?.data?.user;
      setSingleUserData(user);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  const fetchBookingData = async () => {
    try {
      const bookingResp = await getBookingsUserById(id);
      const booking = bookingResp?.data;
      setBookingUserData(booking);
    } catch (error) {
      console.error("Error fetching booking:", error);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row dashboardSection">
        <div className="col-md-12">
          <div className="logisticsMenu logisticsMenuBooking">
            <p>
              <NavLink to={RoutesPaths.DASHBOARD}>
                <img src="/assets/img/homeIcon.svg" alt="" />
              </NavLink>
            </p>
            <img src="/assets/img/chevron-right.svg" alt="" />
            <p>
              <NavLink
                to={RoutesPaths.USERMANAGEMENT}
                style={{ cursor: "pointer" }}
              >
                User management
              </NavLink>
            </p>
            <img src="/assets/img/chevron-right.svg" alt="" />
            <p className="activeSegment">User id : {id}</p>
          </div>
        </div>
        <div className="col-md-12">
          {/* User Info */}
          <div className="rightOrderIdSec commonRightTracking">
            <div>
              <div className="trackingId userDetails">
                <span>Customer name</span>
                <p className="m-0">
                  {isUserLoading ? <Skeleton width={150} height={20} /> : singleUserData?.fullName || "--"}
                </p>
              </div>

              <div className="trackingId userDetails">
                <span>Customer email</span>
                <p className="m-0">
                  {isUserLoading ? <Skeleton width={200} height={20} /> : singleUserData?.email || "--"}
                </p>
              </div>

              <div className="trackingId userDetails">
                <span>Phone number</span>
                <p className="m-0">
                  {isUserLoading ? <Skeleton width={120} height={20} /> : `${singleUserData?.countryCode || "--"} ${singleUserData?.mobileNumber || "--"}`}
                </p>
              </div>
            </div>

            <div>
              <div className="trackingId userDetails">
                <span>Date and time</span>
                <p className="m-0">
                  {isUserLoading
                    ? <Skeleton width={180} height={20} />
                    : (singleUserData?.createdAt
                      ? new Date(singleUserData.createdAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      : "--")
                  }
                </p>
              </div>

              <div className="trackingId userDetails">
                <span>DOB</span>
                <p className="m-0">
                  {isUserLoading
                    ? <Skeleton width={120} height={20} />
                    : (singleUserData?.dob
                      ? new Date(singleUserData.dob).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })
                      : "--")
                  }
                </p>
              </div>

              <div className="trackingId userDetails">
                <span>Gender</span>
                <p className="m-0">
                  {isUserLoading ? <Skeleton width={80} height={20} /> : singleUserData?.gender || "--"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-12 bookingDetailsMain">
            <div className="bookingDetailsOuter">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="bookingDetailsTitle m-0">Order details</h6>

                <NavLink
                  to={`${RoutesPaths.ADDORDER}/${id}`}
                  style={{ textDecoration: "none" }}
                >
                  <button className="createOrderBtnDetail">
                    + Create order
                  </button>
                </NavLink>


                {bookingUserData?.data?.orders?.flatMap(order => order.productDetails || []).length > 5 && (
                  <NavLink
                    to={`${RoutesPaths.BOOKINGMANAGEMENTDETAIL}/${singleUserData?._id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <button className="viewMore">
                      View More
                    </button>
                  </NavLink>

                )}
              </div>

              <div className="TableOverFlow">
                <div className="bookingContent bookingDetailsHeader">
                  <div className="m-0 orderIdWidth">Order id</div>
                  <div className="m-0 userNameWidth">Customer name</div>
                  <div className="m-0 logisticswidth">Phone number</div>
                  <div className="m-0 logisticswidth">Currency</div>
                  <div className="m-0 statusWidth">Date</div>
                  <div className="m-0 statusWidth">Status</div>
                  <div className="m-0 logisticswidth">Total products</div>
                </div>

                {bookingUserData?.data?.orders?.length > 0 ? (
                  bookingUserData.data.orders.slice(0, 5).map((order, index) => (
                    <div className="bookingContent bookingContentData" key={`${order._id}-${index}`}>
                      <div className="m-0 orderIdWidth">#{order.orderId}</div>
                      <div className="m-0 userNameWidth">{order.name || "N/A"}</div>
                      <div className="m-0 logisticswidth">{order.phoneNumber || "N/A"}</div>
                      <div className="m-0 logisticswidth">{order.currency?.toUpperCase() || "N/A"}</div>
                      <div className="m-0 statusWidth">
                        {order.createdAt ? new Date(order.createdAt).toLocaleDateString("en-GB") : "N/A"}
                      </div>
                      <div className="statusWidth">
                        <div className={`badgeBooking ${order.status}Badge widthFitContent`}>
                          <span>{order.status || "N/A"}</span>
                        </div>
                      </div>
                      
                      <div className="m-0 logisticswidth">{order.productDetails?.length || 0}</div>
                    </div>
                  ))
                ) : bookingUserData ? (
                  <p className="noOrders">No order found</p>
                ) : (
                  [...Array(3)].map((_, i) => (
                    <div className="bookingContent bookingContentData" key={i}>
                      <div className="m-0 orderIdWidth"><Skeleton width={80} /></div>
                      <div className="m-0 userNameWidth"><Skeleton width={100} /></div>
                      <div className="m-0 logisticswidth"><Skeleton width={100} /></div>
                      <div className="m-0 logisticswidth"><Skeleton width={80} /></div>
                      <div className="m-0 statusWidth"><Skeleton width={90} /></div>
                      <div className="statusWidth"><Skeleton width={100} height={24} /></div>
                      <div className="m-0 logisticswidth"><Skeleton width={60} /></div>
                    </div>
                  ))
                )}


              </div>



            </div>
          </div>


        </div>
      </div>
    </div>
  );
}
